module.exports = {
    createPatientQRData(_address, _firstName, _middeleInitial, _lastName, _birthday, _race, _gender, _redeemCode, _seed){
        let response = {}
        response.address = _address; 
        response.firstName = _firstName;
        response.middleInitial = _middeleInitial; 
        response.lastName = _lastName;
        response.birthday = _birthday;
        response.race = _race;
        response.gender = _gender;
        response.redeemCode = _redeemCode;
        response.seed = _seed;
        let returner = JSON.stringify(response);
        console.log(returner)
        return returner;
    }
}